/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Totals_RowInputs */

const en_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const fr_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const de_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const it_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const ru_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const es_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const zh_cn2_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const ja_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const hi_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

const pt_pt2_speakers_metrics_totals_row = /** @type {(inputs: Speakers_Metrics_Totals_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals`)
};

/**
* | output |
* | --- |
* | "Totals" |
*
* @param {Speakers_Metrics_Totals_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_totals_row = /** @type {((inputs?: Speakers_Metrics_Totals_RowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Totals_RowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_totals_row(inputs)
	if (locale === "de") return de_speakers_metrics_totals_row(inputs)
	if (locale === "it") return it_speakers_metrics_totals_row(inputs)
	if (locale === "ru") return ru_speakers_metrics_totals_row(inputs)
	if (locale === "es") return es_speakers_metrics_totals_row(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_totals_row(inputs)
	if (locale === "ja") return ja_speakers_metrics_totals_row(inputs)
	if (locale === "hi") return hi_speakers_metrics_totals_row(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_totals_row(inputs)
	return en_speakers_metrics_totals_row(inputs)
});